import React, {useEffect, useState} from 'react';
import {Select, Skeleton} from "antd";
import {useApiLocationCity, useApiLocationProvince} from "@/api/location";

function ProvinceCityCMP({setProvince, setCity, currentProvince, currentCity}) {
    const [myProvince, setMyProvince] = useState()
    const [myCity, setMyCity] = useState()
    const [myCurrentCity, setMyCurrentCity] = useState()
    const [resetCity, setResetCity] = useState(false)

    const {data: provinceData, isLoading: isLoadingProvince} = useApiLocationProvince()
    const {data: cityData, isLoading: isLoadingCity} = useApiLocationCity(myProvince)

    useEffect(() => {
        setMyCurrentCity(currentCity)
    }, [currentCity]);

    useEffect(() => {
        if (myProvince) {
            setProvince(myProvince)
        }

        if (resetCity) {
            setCity('')
            setMyCity('')
            setMyCurrentCity('')
        }

    }, [myProvince])

    useEffect(() => {
        if (currentProvince) {
            setMyProvince(currentProvince)
        }
    }, [currentProvince]);

    useEffect(() => {
        if (currentCity) {
            setCity(currentCity)
        }
    }, [currentCity]);

    useEffect(() => {
        setCity(myCity)
    }, [myCity])

    return (
        <>
            <div className={'mt-1'}>
                {isLoadingProvince && (
                    <>
                        <label htmlFor="province" className="block">استان</label>
                        <Skeleton.Input rootClassName={'mt-2'} block={true} active={true}/>
                    </>
                )}

                {provinceData && provinceData?.data.length > 0 ? (
                    <>
                        <label htmlFor="province" className="block">استان</label>

                        <Select
                            defaultValue={myProvince}
                            value={myProvince}
                            className={'block'}
                            placeholder={'انتخاب کنید'}
                            id={'province'}
                            onChange={(e) => {
                                setMyProvince(e);
                                setResetCity(true)
                            }}
                            options={provinceData?.data.map((value, i) => {
                                return {value: value.key, label: value.fa_name}
                            })}
                        />
                    </>
                ) : null}
            </div>

            {myProvince && isLoadingCity && (
                <>
                    <label htmlFor="province" className="block mt-2">شهر</label>
                    <Skeleton.Input rootClassName={''} block={true} active={true}/>
                </>

            )}
            {myProvince && cityData && cityData?.data?.length > 0 ? (
                <>
                    <label htmlFor="province" className="block mt-2">شهر</label>
                    <Select
                        defaultValue={myCurrentCity}
                        className={'block'}
                        placeholder={'انتخاب کنید'}
                        id={'province'}
                        onChange={(e) => setMyCity(e)}
                        options={cityData?.data?.map((value, i) => {
                            return {value: value.key, label: value.localname}
                        })}
                    />
                </>
            ) : null}
        </>
    );
}

export default ProvinceCityCMP;